var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "info_svg__path-1",
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12m.077-16.672q.104.172.294.172h1.765a.48.48 0 0 0 .351-.172.77.77 0 0 0 .2-.418l.304-1.795q.038-.27-.076-.443a.35.35 0 0 0-.304-.172h-1.747a.48.48 0 0 0-.37.184.72.72 0 0 0-.18.43L12.01 6.91a.6.6 0 0 0 .067.418m-3 12.03q.107.142.318.142h1.634a.5.5 0 0 0 .346-.141.6.6 0 0 0 .192-.344l1.922-9.53a.44.44 0 0 0-.058-.344Q13.335 9 13.143 9h-1.634a.56.56 0 0 0-.355.131.56.56 0 0 0-.202.354l-1.942 9.53a.42.42 0 0 0 .068.344"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_svg__icons-badges-variations",
    transform: "translate(-496 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_svg__icons/info",
    transform: "translate(496 237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_svg__color/gray/70-4A4A4A"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "info_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info_svg__path-1",
    id: "info_svg__Combined-Shape",
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "info_svg__color/black-tint/0-000000",
    fill: "#000",
    mask: "url(#info_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  }))))))));
};
export default SvgInfo;